import { render, staticRenderFns } from "./ProdutorList.vue?vue&type=template&id=e908b24c"
import script from "./ProdutorList.vue?vue&type=script&lang=js"
export * from "./ProdutorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports